import React from "react";
import { Link } from "react-router-dom";
import { Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n";

const C = {
  en: {
    h1: "இலவசம். என்றும் இலவசம். கமிஷன் கிடையாது.",
    tag: "Free to list. Free forever. No commission, ever.",
    intro: "You do the work. The problem is that the people who want to fund it can't find you. List your organisation here at no cost. Upload your registrations, your photographs, your project stories. When a company in your district searches for exactly what you already do, you appear.",
    cta: "Add your organisation — under 20 minutes on a phone",
    getT: "What you get, free",
    get: ["A permanent public profile", "Space for certificates, photographs and videos", "Your projects and updates", "A verification badge once we've checked your papers", "A monthly note telling you who has been looking at your profile"],
    neverT: "What we never do",
    never: ["Charge you", "Take a share of what you raise", "Sell your contact details", "Rank you higher because someone paid us"],
    askT: "What we ask",
    ask: "Accurate information, current registration documents, and — for any photograph showing a child — written consent from their parent or guardian.",
    lawT: "That last one isn't optional.",
    law: " It's the law under the DPDP Rules 2025, and it protects the children in your care. Our onboarding blocks publication of any image with identifiable minors until a guardian-consent record is on file — or offers automatic face-blurring instead.",
  },
  ta: {
    h1: "இலவசம். என்றும் இலவசம். கமிஷன் கிடையாது.",
    tag: "பட்டியலிட இலவசம். என்றென்றும் இலவசம். கமிஷன் இல்லை.",
    intro: "நீங்கள் பணி செய்கிறீர்கள். ஆனால் அதற்கு நிதி அளிக்க விரும்புவோர் உங்களைக் கண்டுபிடிக்க முடிவதில்லை. உங்கள் அமைப்பை இங்கே இலவசமாக பட்டியலிடுங்கள். உங்கள் பதிவுகள், புகைப்படங்கள், கதைகளைப் பதிவேற்றுங்கள். உங்கள் மாவட்டத்தில் ஒரு நிறுவனம் நீங்கள் செய்வதைத் தேடும்போது, நீங்கள் தோன்றுவீர்கள்.",
    cta: "உங்கள் அமைப்பைச் சேர்க்கவும் — தொலைபேசியில் 20 நிமிடங்களுக்குள்",
    getT: "இலவசமாக நீங்கள் பெறுவது",
    get: ["நிரந்தர பொது சுயவிவரம்", "சான்றிதழ்கள், புகைப்படங்கள், வீடியோக்களுக்கு இடம்", "உங்கள் திட்டங்கள் மற்றும் புதுப்பிப்புகள்", "ஆவணங்கள் சரிபார்க்கப்பட்டதும் ஒரு சரிபார்ப்பு பேட்ஜ்", "உங்கள் சுயவிவரத்தைப் பார்த்தவர்களைப் பற்றிய மாதாந்திர குறிப்பு"],
    neverT: "நாங்கள் என்றும் செய்யாதவை",
    never: ["உங்களிடம் கட்டணம் வசூலிப்பது", "நீங்கள் திரட்டுவதில் பங்கு எடுப்பது", "உங்கள் தொடர்பு விவரங்களை விற்பது", "பணம் பெற்று உயர் இடத்தில் வைப்பது"],
    askT: "நாங்கள் கேட்பது",
    ask: "துல்லியமான தகவல், தற்போதைய பதிவு ஆவணங்கள், மற்றும் — குழந்தை தெரியும் எந்த புகைப்படத்திற்கும் — பெற்றோர்/பாதுகாவலரின் எழுத்துப்பூர்வ ஒப்புதல்.",
    lawT: "அந்த கடைசி விஷயம் விருப்பமானது அல்ல.",
    law: " இது DPDP விதிகள் 2025-ன் படி சட்டம், உங்கள் பராமரிப்பில் உள்ள குழந்தைகளைப் பாதுகாக்கிறது. அடையாளம் காணக்கூடிய குழந்தைகள் உள்ள படங்களை, ஒப்புதல் பதிவு இல்லாமல் வெளியிட எங்கள் அமைப்பு தடுக்கிறது — அல்லது தானாக முகம் மங்கலாக்கலை வழங்குகிறது.",
  },
  hi: {
    h1: "सूचीबद्ध करना मुफ़्त। हमेशा मुफ़्त। कोई कमीशन नहीं।",
    tag: "सूचीबद्ध करना मुफ़्त। हमेशा मुफ़्त। कभी कोई कमीशन नहीं।",
    intro: "काम आप करते हैं। समस्या यह है कि जो लोग इसे निधि देना चाहते हैं वे आपको ढूँढ नहीं पाते। अपनी संस्था यहाँ नि:शुल्क सूचीबद्ध करें। अपने पंजीकरण, तस्वीरें और परियोजना कहानियाँ अपलोड करें। जब आपके ज़िले में कोई कंपनी वही खोजती है जो आप करते हैं, तो आप दिखते हैं।",
    cta: "अपनी संस्था जोड़ें — फ़ोन पर 20 मिनट से कम में",
    getT: "आपको मुफ़्त में क्या मिलता है",
    get: ["एक स्थायी सार्वजनिक प्रोफ़ाइल", "प्रमाणपत्र, तस्वीरें और वीडियो के लिए जगह", "आपकी परियोजनाएँ और अपडेट", "आपके कागज़ जाँचने के बाद एक सत्यापन बैज", "एक मासिक नोट जो बताता है कि आपकी प्रोफ़ाइल किसने देखी"],
    neverT: "हम कभी नहीं करते",
    never: ["आपसे शुल्क लेना", "आपके जुटाए धन में हिस्सा लेना", "आपके संपर्क विवरण बेचना", "पैसे लेकर किसी को ऊपर रैंक करना"],
    askT: "हम क्या माँगते हैं",
    ask: "सटीक जानकारी, वर्तमान पंजीकरण दस्तावेज़, और — बच्चे की किसी भी तस्वीर के लिए — माता-पिता या अभिभावक की लिखित सहमति।",
    lawT: "वह आख़िरी बात वैकल्पिक नहीं है।",
    law: " यह DPDP नियम 2025 के तहत क़ानून है, और यह आपकी देखभाल में बच्चों की रक्षा करता है। पहचान-योग्य नाबालिगों वाली किसी भी तस्वीर को अभिभावक-सहमति रिकॉर्ड के बिना प्रकाशित होने से हमारी प्रणाली रोकती है — या स्वचालित चेहरा-धुंधला विकल्प देती है।",
  },
};

export default function ForNGOs() {
  const { lang } = useT();
  const c = C[lang] || C.en;
  return (
    <div>
      <section className="bg-terracotta text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-16">
          <h1 className="text-3xl sm:text-4xl font-extrabold">{c.h1}</h1>
          <p className="text-lg font-semibold mt-2 text-white/90">{c.tag}</p>
          <p className="text-white/85 mt-4 measure">{c.intro}</p>
          <Button asChild className="mt-6 bg-white text-terracotta hover:bg-stone-100" data-testid="ngo-add-btn"><Link to="/register">{c.cta}</Link></Button>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-xl font-bold text-slate-brand mb-3">{c.getT}</h2>
          {c.get.map((x) => (
            <div key={x} className="flex items-start gap-2 text-sm text-stone-700 mb-2"><Check size={16} className="text-tier3-icon shrink-0 mt-0.5" /> {x}</div>
          ))}
          <h2 className="text-xl font-bold text-slate-brand mb-3 mt-6">{c.neverT}</h2>
          {c.never.map((x) => (
            <div key={x} className="flex items-start gap-2 text-sm text-stone-700 mb-2"><X size={16} className="text-red-500 shrink-0 mt-0.5" /> {x}</div>
          ))}
        </div>
        <div className="bg-white rounded-xl border border-stone-200 p-6 h-fit">
          <h2 className="text-xl font-bold text-slate-brand mb-3">{c.askT}</h2>
          <p className="text-sm text-stone-700 measure">{c.ask}</p>
          <div className="mt-4 rounded-lg bg-amber-50 border border-amber-200 p-4 text-sm text-amber-900">
            <strong>{c.lawT}</strong>{c.law}
          </div>
        </div>
      </section>
    </div>
  );
}
